import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    isLoading: Boolean,
    reloadStatus: Boolean,
  };

  connect() {
    if (this.isLoadingValue && this.reloadStatusValue) {
      setTimeout(() => {
        // Between page render and now, the status may have updated.
        Turbo.visit("/portal/membership_status", { frame: "customer_portal_membership_status" });
      }, 0);
    }
  }
}
